import { render, staticRenderFns } from "./ArchiveFolderDialog.vue?vue&type=template&id=bba9d448&scoped=true"
import script from "./ArchiveFolderDialog.vue?vue&type=script&lang=js"
export * from "./ArchiveFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba9d448",
  null
  
)

export default component.exports